import React, { useContext, useState } from "react";
import useContextMenu from "../../contexts/useContextMenu";
import SocketContext from "../../contexts/SocketContext";

const ProdNameListSelector = ({
  singleProdCatNameData,
  selectedProdName,
  setSelectedProdName,
  setShowProdDetails,
  setSelectedProduct,
  setSelectedProducer,
  setProdNameEdits,
  setEditingPN,
  selectedProduct,
}) => {
  const { clicked, setClicked, points, setPoints } = useContextMenu();
  const [activeIndex, setActiveIndex] = useState();

  // Socket
  const { socket } = useContext(SocketContext);

  // Leave Product Room Promise
  const leaveroom = (item) => {
    return new Promise((resolve, reject) => {
      socket.emit("leaveproductRoom", selectedProduct.productID);
      resolve();
    });
  };

  // Select Product
  const selectProduct = async () => {
    if (selectedProduct && selectedProduct.productID) {
      await leaveroom(selectedProduct.productID);
    }
  };
  return (
    <div className='prodNameListSelector'>
      {singleProdCatNameData && Object.keys(singleProdCatNameData).length > 0 && (
        <h3 style={{ position: "sticky", top: 0, background: "var(--white)" }}>Select ProdName:</h3>
      )}
      {singleProdCatNameData
        ? Object.keys(singleProdCatNameData)
            .sort()
            .map((key, index) => {
              if (key !== "null") {
                return (
                  <>
                    <p
                      onClick={(e) => {
                        selectProduct();
                        setSelectedProdName(key);
                        setShowProdDetails(false);
                        setSelectedProduct(null);
                        setSelectedProducer("");
                        // setProdNameEdits({
                        //   ["prodNameID"]:
                        //     singleProdCatNameData[key][0]["prodNameID"],
                        //   ["prodCatNameID"]:
                        //     singleProdCatNameData[key][0]["prodCatNameID"],
                        //   ["prodCatName"]:
                        //     singleProdCatNameData[key][0]["prodCatName"],
                        //   ["abbreviation"]:
                        //     singleProdCatNameData[key][0]["abbreviation"],
                        //   ["prodName"]:
                        //     singleProdCatNameData[key][0]["prodName"],
                        //   ["BUID"]: singleProdCatNameData[key][0]["BUID"],
                        //   ["businessUnit"]:
                        //     singleProdCatNameData[key][0]["businessUnit"],
                        //   ["IMOID"]: singleProdCatNameData[key][0]["IMOID"],
                        //   ["IMO"]: singleProdCatNameData[key][0]["IMO"],
                        //   ["prodGroupID"]:
                        //     singleProdCatNameData[key][0]["prodGroupID"],
                        //   ["productGroup"]:
                        //     singleProdCatNameData[key][0]["productGroup"],
                        // });
                        setClicked(false);
                        setEditingPN(false);
                      }}
                      className={selectedProdName === key ? "activeListSelector" : ""}
                      onContextMenu={(e) => {
                        e.preventDefault();
                        selectProduct();
                        setSelectedProdName(key);
                        setShowProdDetails(false);
                        setSelectedProduct(null);
                        setSelectedProducer("");
                        // setProdNameEdits({
                        //   ["prodNameID"]:
                        //     singleProdCatNameData[key][0]["prodNameID"],
                        //   ["prodCatNameID"]:
                        //     singleProdCatNameData[key][0]["prodCatNameID"],
                        //   ["prodCatName"]:
                        //     singleProdCatNameData[key][0]["prodCatName"],
                        //   ["abbreviation"]:
                        //     singleProdCatNameData[key][0]["abbreviation"],
                        //   ["prodName"]:
                        //     singleProdCatNameData[key][0]["prodName"],
                        //   ["BUID"]: singleProdCatNameData[key][0]["BUID"],
                        //   ["businessUnit"]:
                        //     singleProdCatNameData[key][0]["businessUnit"],
                        //   ["IMOID"]: singleProdCatNameData[key][0]["IMOID"],
                        //   ["IMO"]: singleProdCatNameData[key][0]["IMO"],
                        //   ["prodGroupID"]:
                        //     singleProdCatNameData[key][0]["prodGroupID"],
                        //   ["productGroup"]:
                        //     singleProdCatNameData[key][0]["productGroup"],
                        // });
                        setClicked(true);
                        setPoints({ x: e.pageX, y: e.pageY });
                        setActiveIndex(index);
                        setEditingPN(false);
                      }}
                      key={key}
                    >
                      {key}
                    </p>
                    <div style={{ position: "relative", overflow: "visible" }}>
                      {clicked && activeIndex === index && (
                        <div className='contextMenu'>
                          <ul onContextMenu={(e) => e.preventDefault()}>
                            <li
                              onClick={(e) => {
                                setSelectedProdName(key);
                                setShowProdDetails(false);
                                setSelectedProduct(null);
                                setSelectedProducer("");
                                setEditingPN(true);
                                setClicked(false);
                                setProdNameEdits({
                                  ["prodNameID"]: singleProdCatNameData[key][0]["prodNameID"],
                                  ["prodCatNameID"]: singleProdCatNameData[key][0]["prodCatNameID"],
                                  ["prodCatName"]: singleProdCatNameData[key][0]["prodCatName"],
                                  ["abbreviation"]: singleProdCatNameData[key][0]["abbreviation"],
                                  ["prodName"]: singleProdCatNameData[key][0]["prodName"],
                                  ["BUID"]: singleProdCatNameData[key][0]["BUID"],
                                  ["businessUnit"]: singleProdCatNameData[key][0]["businessUnit"],
                                  ["IMOID"]: singleProdCatNameData[key][0]["IMOID"],
                                  ["IMO"]: singleProdCatNameData[key][0]["IMO"],
                                  ["prodGroupID"]: singleProdCatNameData[key][0]["prodGroupID"],
                                  ["productGroup"]: singleProdCatNameData[key][0]["productGroup"],
                                });
                              }}
                            >
                              Edit
                            </li>
                            <li>Delete</li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </>
                );
              }
            })
        : ""}
    </div>
  );
};

export default ProdNameListSelector;
